import { render, staticRenderFns } from "./mnavbar.vue?vue&type=template&id=91bdcd74&"
import script from "./mnavbar.vue?vue&type=script&lang=js&"
export * from "./mnavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports